<div class="row">
    <otb-inner-breadcrumb
        *otbShowInEnv="['default', 'justice', 'finance', 'sh', 'hmdj', 'bb-jm']"
    ></otb-inner-breadcrumb>
    <otb-progress-bar></otb-progress-bar>
</div>
<div class="row">
    <div class="col-12">
        <h2 [innerHTML]="'dynamische_frontend_texte.terminart.ueberschrift' | translate | safeStyle"></h2>
    </div>

    <div class="col-12 mt-5">
        <form id="agency-service-selection" [formGroup]="appointmentTypeFormGroup" (ngSubmit)="onSubmit()" #mainForm>
            <div class="row">
                <div class="col-12 col-sm-6">
                    <div class="form-group">
                        <label
                            for="citizen-appointment-type"
                            [innerHTML]="'dynamische_frontend_texte.terminart.label' | translate | required | safeStyle"
                        ></label>
                        <ng-select
                            labelForId="citizen-appointment-type"
                            [items]="appointmentTypeOptions"
                            bindLabel="value"
                            bindValue="name"
                            (change)="onAppointmentTypeSelect($event)"
                            formControlName="type"
                            [clearable]="false"
                            [clearOnBackspace]="false"
                            placeholder="Online-Beratung"
                            [markFirst]="false"
                            notFoundText="Keine Einträge gefunden"
                            [inputAttrs]="{ 'aria-describedby': 'citizen-appointment-type-error' }"
                            dropdownCustomHoverColorDirective
                            otbAnnounceSearchResults
                        ></ng-select>
                        <otb-form-error-message
                            id="citizen-appointment-type-error"
                            [show]="formAppointmentType.invalid && formAppointmentType.dirty"
                        ></otb-form-error-message>
                    </div>
                </div>

                <div class="form-group d-flex justify-content-between gap-2 flex-md-row flex-column mt-4">
                    <otb-back-button></otb-back-button>

                    <button
                        type="submit"
                        class="btn-success btn order-md-2 order-1 m-0 mb-3 mb-sm-0"
                        accesskey="w"
                        btnPrimaryColorDirective
                        [innerHTML]="'dynamische_frontend_texte.shared.button.next' | translate | safeStyle"
                    ></button>
                </div>
            </div>
        </form>
    </div>
</div>
